<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import EventDetail from '@/components/shared/CommonDetail.vue'

  export default {
    components: {
      EventDetail
    },
    data() {
      return {
        Events: [],
        IsLiked: false,
        IsFavorite: false
      }
    },
    computed: {
      ...mapGetters([
        'AppConfig',
        'MainMenuLayout',
        'ContentPage',
        'resource'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      headerElements() {
        let contentData = this.ContentPage
        let headerElements
        if (contentData.Parent.HeaderElements) {
          headerElements = JSON.parse(contentData.Parent.HeaderElements)
        }
        return headerElements
      },
      footerElements() {
        let contentData = this.ContentPage
        let footerElements
        if (contentData.Parent.FooterElements) {
          footerElements = JSON.parse(contentData.Parent.FooterElements)
        }
        return footerElements
      },
      onePost() {
        if (this.ContentPage.ContentPages.length === 1 &&
        this.ContentPage.ContentPages[0].Posts.length === 1) {
          return true
        }
        return false
      },
      headerTitle() {
        if (this.onePost) {
          return this.ContentPage.ContentPages[0].Posts[0].Title
        } else {
          return this.ContentPage.Parent.PageTitle
        }
      },
      onePostDetails() {
        if (this.onePost) {
          return this.ContentPage.ContentPages[0].Posts[0]
        } else {
          return {}
        }
      },
      Favorite() {
        if (Helper.IsValid(this.onePostDetails)) {
          this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
        }
        return this.IsFavorite
      },
      IsLike() {
        if (Helper.IsValid(this.onePostDetails)) {
          this.IsLiked = Helper.convertBoolean(this.onePostDetails.IsLiked)
        }
        return this.IsLiked
      },
      AllowLikes() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowLikes)
      },
      AllowAddingToFavorites() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowAddingToFavorites)
      },
      AllowSharing() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowSharing)
      },
      AllowComments() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowComments)
      },
      EventDetailListFuture() {
        return this.Events.map(event => { return {
            Category : event.Category,
            Posts: event.Posts.map(post => {
              return {
                ...post,
                IsPastEvent: Helper.CheckDateIsFutureDate(post)
              }
            })
          }
        })
      }
    },
    watch: {
      ContentPage: function(ContentPage) {
        this.Events = ContentPage.ContentPages.filter(page => {
          return page.Posts.sort(function(a, b) { return a.OrderId - b.OrderId })
        })
      }
    },
    created() {
      this.initEventModule(this.SubscriptionModuleId)
    },
    mounted() {
      if (this.$refs.eventPage) {
        this.$refs.eventPage.$on('page:reinit', (event, payload) => {
          this.initEventModule(this.SubscriptionModuleId)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.eventPage) {
        this.$refs.eventPage.$off('page:reinit', (event, payload) => {
          this.initEventModule(this.SubscriptionModuleId)
        })
      }
    },
    methods: {
      ...mapActions([
        'loadContentPagesLocalData',
        'loadContentPages',
        'addUpdateLike',
        'shareInformation',
        'addMyFavorite',
        'resetContentPageData'
      ]),
      initEventModule(SubscriptionModuleId) {
        this.$showLoader()
        this.resetContentPageData()
        this.loadContentPagesLocalData(SubscriptionModuleId)
        this.loadContentPages(SubscriptionModuleId).then(() => {
          setTimeout(() => {
            if (this.onePost) {
              this.$hideLoader()
              this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.onePostDetails.Id, 'ViewType': 2})
            } else {
              this.$hideLoader()
              this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.ContentPage.Parent.Id, 'ViewType': 1})
            }
          }, 1000)
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      subtitle: function(noOflike, noOfComment) {
        if (this.AllowLikes && this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span> <span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        } else if (this.AllowLikes) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span></div>'
        } else if (this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        }
      },
      eventDetailUrl: function(value) {
        return '/event-detail-view/' + this.SubscriptionModuleId + '/' + value
      },
      IsValid: function(value) {
        return Helper.IsValid(value)
      },
      formattedDate: function(value) {
        return Helper.FormattedDateDDMMMMYY(value)
      },
      EventDateTime: function(obj) {
        return Helper.EventDateTime(obj, this.resource.strUhr)
      },
      day: function(value) {
        return Helper.EventFormatDate(value, 'DD')
      },
      month: function(value) {
        return Helper.EventFormatDate(value, 'MMM')
      },
      getStyle: function(value) {
        if (this.IsValid(value)) {
          return { 'background-image': 'url(' + this.AppConfig.Urls.ContentAssetsBaseUrl + value + ')' }
        } else {
          return {}
        }
      },
      onLikeClick() {
        let Like = {
          ModulesContentPages_Id: this.onePostDetails.ModulesContentPages_Id,
          Reference_Id: this.onePostDetails.Id,
          Liked: !Helper.convertBoolean(this.onePostDetails.IsLiked),
          AppGUID: this.AppConfig.AppGUID,
          ContentType: 1,
          NotificationContent: {
            Title: this.onePostDetails.Title,
            ImageName: this.onePostDetails.PostImage,
            Comment: '',
            Navigationurl: this.eventDetailUrl(this.onePostDetails.Id)
          }
        }
        this.addUpdateLike(Like).then(() => {
          this.$f7.notification.create({
            title: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle,
            subtitle: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
            cssClass: 'success-notification',
            closeOnClick: true,
            closeTimeout: 3000
          }).open()
        })
      },
      onShareCLick() {
        let Options = {
          appConfig: this.AppConfig,
          moduleId: this.ContentPage.Parent.Module_Id,
          subscriptionModuleId: this.ContentPage.Parent.SubscriptionModule_Id,
          shareId: this.onePostDetails.Id,
          path: Helper.CurrentlocationURL(),
          orderId: 0
        }
        this.shareInformation(Options)
      },
      onFavoriteClick() {
        let favData = {
          Reference_Id: this.onePostDetails.Id,
          ReferenceParent_Id: this.onePostDetails.ModulesContentPages_Id
        }
        this.addMyFavorite(favData)
        this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
      },
      filterEvent(events, value) {
        let flag = value === ('Future' || 'Current') ? true : false
        let clon = events.filter(e => { return e.eventTag == value})
        let orderedEventList =  clon.sort((a, b) => { 
          let aDate
          let bDate
          if(Helper.IsValid(a.EventStartDate, true) && Helper.IsValid(a.EventStartTime, true)) {
            aDate = Helper.ConvertToUnixDateTime(`${a.EventStartDate.substring(0, 10)}T${a.EventStartTime}`)
          } else {
            aDate = Helper.ConvertToUnixDateTime(a.EventStartDate)
          }
          if(Helper.IsValid(b.EventStartDate, true) && Helper.IsValid(b.EventStartTime, true)) {
            bDate = Helper.ConvertToUnixDateTime(`${b.EventStartDate.substring(0, 10)}T${b.EventStartTime}`)
          } else {
            bDate = Helper.ConvertToUnixDateTime(b.EventStartDate)
          }
          return flag ? aDate - bDate : bDate - aDate
        })
        return orderedEventList
      }
    }
  }
</script>
<template>
  <f7-page ref="eventPage" :page-content="false" :name="'event-view-'+ SubscriptionModuleId" v-if="ContentPage">
    <app-header :header="headerTitle" :isShowRightNavBar="!onePost"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1 && !onePost"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <app-floating-button v-if="onePost && onePostDetails"
      :ShowLike="AllowLikes"
      :ShowFavorite="AllowAddingToFavorites"
      :ShowShare="AllowSharing"
      :IsLike="IsLike"
      :IsFavorite="Favorite"
      :onLikeClick="onLikeClick"
      :onFavoriteClick="onFavoriteClick"
      :onShareCLick="onShareCLick"
    ></app-floating-button>
    <div class="backgroundimg"></div>
    <f7-page-content v-if="!onePost && ContentPage.ContentPages">
      <div v-if="headerElements" class="header-section">
        <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
      <div v-for="(Event, index) in EventDetailListFuture" :key="index">
        <f7-block class="past-event-title" v-if="filterEvent(Event.Posts, 'Current').length > 0">{{resource.strCurrentEvent}}</f7-block>
        <f7-link class="list_display_block" v-for="(PostDetails) in filterEvent(Event.Posts, 'Current')" :key="PostDetails.Id" :href="eventDetailUrl(PostDetails.Id)">
          <f7-card>
            <f7-card-header
              valign="bottom" :class="{'no-border' : true, card__headerNoImage : !IsValid(PostDetails.PostImage) , card__headerImage : IsValid(PostDetails.PostImage) }"
              :style="getStyle(PostDetails.PostImage)">
              <div :class="{card__headerNoImageCaption : !IsValid(PostDetails.PostImage) , card__headerImageCaption : IsValid(PostDetails.PostImage) }">
                <div class="card__headerCalendar">
                  <div Class="card__headerCalendarDate">
                    {{day(PostDetails.EventStartDate)}}
                    <div Class="card__headerCalendarMonth">
                      {{month(PostDetails.EventStartDate)}}
                    </div>
                  </div>
                </div>
                <div class="card__headerDesc">
                  <div class="card__CaptionText">{{PostDetails.Title}}</div>
                  <div class="card__headerOption">
                    <div class="headerOption__date"> {{EventDateTime(PostDetails)}}</div>
                    <div class="headerOption__item" v-html="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)">
                    </div>
                  </div>
                </div>
              </div>
            </f7-card-header>
          </f7-card>
        </f7-link>
        <f7-block class="past-event-title" v-if="filterEvent(Event.Posts, 'Future').length > 0">{{resource.strFutureEvent}}</f7-block>
        <f7-link class="list_display_block" v-for="(PostDetails) in filterEvent(Event.Posts, 'Future')" :key="PostDetails.Id" :href="eventDetailUrl(PostDetails.Id)">
          <f7-card>
            <f7-card-header
              valign="bottom" :class="{'no-border' : true, card__headerNoImage : !IsValid(PostDetails.PostImage) , card__headerImage : IsValid(PostDetails.PostImage) }"
              :style="getStyle(PostDetails.PostImage)">
              <div :class="{card__headerNoImageCaption : !IsValid(PostDetails.PostImage) , card__headerImageCaption : IsValid(PostDetails.PostImage) }">
                <div class="card__headerCalendar">
                  <div Class="card__headerCalendarDate">
                    {{day(PostDetails.EventStartDate)}}
                    <div Class="card__headerCalendarMonth">
                      {{month(PostDetails.EventStartDate)}}
                    </div>
                  </div>
                </div>
                <div class="card__headerDesc">
                  <div class="card__CaptionText">{{PostDetails.Title}}</div>
                  <div class="card__headerOption">
                    <div class="headerOption__date"> {{EventDateTime(PostDetails)}}</div>
                    <div class="headerOption__item" v-html="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)">
                    </div>
                  </div>
                </div>
              </div>
            </f7-card-header>
          </f7-card>
        </f7-link>
        <f7-block class="past-event-title" v-if="filterEvent(Event.Posts, 'Past').length > 0">{{resource.strPastEvent}}</f7-block>
        <f7-link class="list_display_block" v-for="(PostDetails) in filterEvent(Event.Posts, 'Past')" :key="PostDetails.Id" :href="eventDetailUrl(PostDetails.Id)">
          <f7-card>
            <f7-card-header
              valign="bottom" :class="{'no-border' : true, card__headerNoImage : !IsValid(PostDetails.PostImage) , card__headerImage : IsValid(PostDetails.PostImage) }"
              :style="getStyle(PostDetails.PostImage)">
              <div :class="{card__headerNoImageCaption : !IsValid(PostDetails.PostImage) , card__headerImageCaption : IsValid(PostDetails.PostImage) }">
                <div class="card__headerCalendar">
                  <div Class="card__headerCalendarDate">
                    {{day(PostDetails.EventStartDate)}}
                    <div Class="card__headerCalendarMonth">
                      {{month(PostDetails.EventStartDate)}}
                    </div>
                  </div>
                </div>
                <div class="card__headerDesc">
                  <div class="card__CaptionText">{{PostDetails.Title}}</div>
                  <div class="card__headerOption">
                    <div class="headerOption__date"> {{EventDateTime(PostDetails)}}</div>
                    <div class="headerOption__item" v-html="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)">
                    </div>
                  </div>
                </div>
              </div>
            </f7-card-header>
          </f7-card>
        </f7-link>
      </div>
      <div v-if="footerElements" class="footer-section">
        <component v-for="(el,index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
    </f7-page-content>
    <event-detail v-if="onePost && ContentPage.ContentPages" :Parent="ContentPage.Parent" :PostDetails="onePostDetails" :SubscriptionModuleId="SubscriptionModuleId" IsFrom="Event"></event-detail>
  </f7-page>
</template>
<style scoped>
  .past-event-title {
    font-size: 20px;
    font-weight: 700;
    color: inherit;
    text-align: center;
    margin-bottom: 25px !important;
  }
  .card__headerImage {
    min-height: 50vw;
    padding: 0px;
    background-position: 50% 50%!important;
    background-repeat: no-repeat!important;
    background-size: cover!important;
  }

  .card__headerImageCaption {
    width: 100%;
    height: 33%;
    background-color: rgba(28, 29, 31, 0.6);
    background: linear-gradient(180deg,transparent,rgba(0, 0, 0, 0.6) 30%, rgba(0, 0, 0, 0.8))!important;
  }
  .card__headerNoImageCaption {
    width: 100%;
    height: 33%;
  }

  .card__CaptionText {
    text-transform: uppercase;
    /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;*/
    padding: 10px 15px 2px 5px;
    font-weight: bold;
    font-size: 1.0em;
  }

  .card__headerOption {
    padding: 0px 15px 10px 5px;
    overflow: hidden;
    font-size: 0.7em;
  }

  .card__headerOption .headerOption__date {
    float: left;
  }

  .card__headerOption .headerOption__item {
    float: right;
  }

  .card__headerNoImage {
    padding: 0;
  }

  .card__headerNoImage .card__headerImageCaption {
    background-color: transparent;
  }

  .headerOption__item .icon-dislike,
  .headerOption__item .icon-comment {
    display: inline-block;
    width: 9px;
    height: 9px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .card__headerCalendar {
    float: left;
    padding: 10px;
  }

  .card__headerCalendarDate {
    width: 35px;
    height: 2.1em;
    background-color: #fff;
    color: #333;
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 1.2em;
    margin-left: 5px;
  }

  .card__headerCalendarMonth {
    position: absolute;
    width: 100%;
    background-color: #007aff;
    color: #fff;
    bottom: 0;
    font-size: 0.5em;
    padding: 1px 0 1px 0;
  }

  .card__headerDesc {
    margin-left: 60px;
  }
  .card__headerCalendarMonth {
     text-transform: uppercase;
  }
  .floating-button-toolbar, .speed-dial{
    bottom: 15px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/event/Event.vue